module.exports = __webpack_public_path__ + "img/outgoing-call-w.1ff5feef.svg";